module.exports = __webpack_public_path__ + "img/top.e5a6b76d.png";